module.exports = __webpack_public_path__ + "static/media/Carousel-1-small.c896f017.webp";